import type { AccountExportPreview } from "../types";

/**
 * Orders preview rows so unmatched domains (no CRM suggestions → "Create new company")
 * come first. Applied once when preview data arrives; per-row dropdown changes only
 * mutate `accountId`, never `matchedCompanies`, so the order stays stable afterwards.
 * Relies on `Array.prototype.sort` stability to preserve the API order within each group.
 */
export const sortAccountsPreview = <T extends Pick<AccountExportPreview, "matchedCompanies">>(
    preview: readonly T[],
): T[] =>
    [...preview].sort(
        (a, b) => Number(a.matchedCompanies.length > 0) - Number(b.matchedCompanies.length > 0),
    );
